/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * Secret key in PEM-encoded PKCS#8 format.
 * Examples on how to generate it by openssl:
 *   openssl genpkey -algorithm ed25519 | openssl pkcs8 -nocrypt -topk8
 *   openssl ecparam -name secp256r1 -noout -genkey | openssl pkcs8 -nocrypt -topk8
 *   openssl ecparam -name secp384r1 -noout -genkey | openssl pkcs8 -nocrypt -topk8
 *   openssl ecparam -name secp256k1 -noout -genkey | openssl pkcs8 -nocrypt -topk8
 * .
 */
export type KeySecretPkcs8 = string;
